import React, { useState, useEffect } from 'react';
import * as Icons from "../common/icons";
import { showSuccess, showError, showInfo } from "../common/iziToast";
import { useTranslation } from 'react-i18next';

export default function LoyaltyPointsPriceSwitch({ totalLoyaltyPoints, canPayWithLoyaltyPoints, onTogglePayWithLoyaltyPoints, isLoyaltyPointsUsed, isReadOnly, as: Wrapper = 'td', style }) {
    const [isOn, setIsOn] = useState(isLoyaltyPointsUsed);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    const handleToggle = async () => {
        if (isReadOnly) return;
        try {
            if (isOn) {
                onTogglePayWithLoyaltyPoints(false);
                setIsOn(false);
                return;
            }

            setIsLoading(true);

            const conditionsMet = canPayWithLoyaltyPoints(); //await this.props.onValidateTurnOn();

            if (conditionsMet) {
                onTogglePayWithLoyaltyPoints(true);
                setIsOn(true); // Turn green
            } else {
                // Do nothing. It stays greyed out.
                console.warn("Conditions not met. Switch remains off.");
                showInfo(
                    t("PayWithLoyaltyPoints"),
                    t("InsufficientLoyaltyPointsBalance"),
                    Icons.INFO,
                );
            }
        } catch (error) {
            showError(
                t("PayWithLoyaltyPoints"),
                t("ErrorPayingWithLoyaltyContactSupport"),
                Icons.ERROR,
            );
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <Wrapper className="text-center text-lg text-medium" style={style}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                <span style={{ fontWeight: '500' }}>
                    {totalLoyaltyPoints}
                </span>
                <button
                    role="switch"
                    aria-checked={isOn}
                    onClick={handleToggle}
                    disabled={isLoading || isReadOnly}
                    style={{
                        position: 'relative',
                        width: '44px',
                        height: '24px',
                        borderRadius: '24px',
                        border: 'none',
                        backgroundColor: isOn ? '#28a745' : '#e9ecef',
                        opacity: isReadOnly ? 0.5 : isLoading ? 0.7 : 1,
                        cursor: isReadOnly ? 'not-allowed' : isLoading ? 'wait' : 'pointer',
                        transition: 'background-color 0.3s ease',
                        padding: 0,
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            top: '2px',
                            left: isOn ? '22px' : '2px', 
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            backgroundColor: '#fff',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            transition: 'left 0.3s ease',
                        }}
                    />
                </button>
            </div>
        </Wrapper>
    )
}